import * as Yup from "yup";
import FormDefault from '../../components/Forms/FormDefault';
import { requestAuth } from "../../components/services/RequestService";
import { toast } from "react-toastify";

export const AddNewPaymentReqForm = (props) => {
    const { reload, onClose, formFields = [], fileRef = 'url', rol } = props;

    async function uploadFile(values) {
        if (typeof values[fileRef] === "string") {
            onSubmit({ ...values });
        } else if (values[fileRef]) {
            let formData = new FormData();
            formData.append("Name", values[fileRef].name);
            formData.append("File", values[fileRef]);
            formData.append("originalName", values[fileRef].name);
            formData.append("Status", "verified");
            // formData.append("ProcedureId", values.id);

            await requestAuth("post", "/files", formData)
                .then((res) => {
                    onSubmit({
                        ...values,
                        [fileRef]: res.data.url,
                    });
                })
                .catch(() => {
                    toast.error("Se produjo un error al subir el archivo");
                });
        } else {
            onSubmit(values);
        }
    }

    function editOnSubmit(values) {
        onSubmit(values);
    }
    async function onSubmit(values) {
        // console.log(values)
        const newOptionsKeys = Object.keys(values).filter(
            (key) => key.endsWith("_isNew") && values[key]
        );

        for (const key of newOptionsKeys) {
            const baseKey = key.replace("_isNew", "");

            const fieldConfig = formFields.find((f) => f.name === baseKey);
            if (!fieldConfig || !fieldConfig.urlApi) {
                console.warn(`No se encontró 'urlApi' para el campo '${baseKey}'`);
                continue;
            }

            const parts = fieldConfig.urlApi.split("/");
            const dropdownListLabel = parts[parts.length - 2];

            const valueToCreate = values[baseKey];
            if (valueToCreate) {
                await handleCreateOption(baseKey, valueToCreate, dropdownListLabel);
            }
        }

        const details = {};
        Object.keys(values)
            .filter((key) => key.startsWith("det_"))
            .forEach((key) => {
                details[key] = values[key];
            });

        const payload = {
            ...values,
            details: JSON.stringify(details),
        };

        await requestAuth(
            values.id ? "put" : "post",
            `/procElement/withSubElement`,
            payload
        )
            .then(() => {
                reload();
                onClose();
                toast.success("Registro exitoso");
            })
            .catch(() => {
                toast.error("Se produjo un error al guardar");
            });
    }

    async function handleCreateOption(fieldName, value, dropdownListLabel) {
        await requestAuth("post", "/dropdown/option", {
            Name: value,
            DropdownListLabel: dropdownListLabel,
        });
    }

    return (
        <div className="mb-6 min-w-[300px]">
            <FormDefault
                tittle="Agregar nueva solicitud"
                fields={[
                    // {
                    //     label: "ProcedureId",
                    //     name: "procedureId",
                    //     typeInput: "number"
                    // },
                    // {
                    //     label: "Trámite",
                    //     name: "stringNumberProc",
                    //     typeInput: "number"
                    // },
                    // {
                    //     label: "Despacho",
                    //     name: "procedureId",
                    //     typeInput: "selectAsync",
                    //     urlApi: `procedure/bySelect?procedureTypeId=${type === 'importacion' ? 1 : 2}`,
                    //     value: "id",
                    //     labelOption: "numberString",
                    // },
                    ...(
                        rol === 'liq' ?
                            []
                            :
                            [
                                {
                                    label: "Nro. correlativo",
                                    name: "mainNum",
                                    typeInput: "number"
                                },
                            ]
                    ),
                    // {
                    //     label: "Tipo de documento",
                    //     name: "label",
                    //     typeInput: "select",
                    //     urlApi: `dropdown/documentos-para-solicitudes-de-${type}/options`,
                    //     value: "name",
                    //     labelOption: "name",
                    // },
                    // ...formFields
                ]}
                initialValues={{
                    Type: "paymentRequest",
                }}
                validationSchema={Yup.object().shape({
                    // CompanyId: Yup.string().required("Este campo es obligatorio"),
                    // ProcedureId: Yup.string().required("Este campo es obligatorio"),
                })}
                onSubmit={(values) =>
                    !values[fileRef] || (typeof values[fileRef] === "string")
                        ? editOnSubmit(values)
                        : uploadFile(values)
                }
                buttonName="Agregar"
            />
        </div>
    );
}
